import Hero from "@/components/Hero";
import Services from "@/components/Services";
import About from "@/components/About";
import ReviewsPreview from "@/components/ReviewsPreview";
import Contact from "@/components/Contact";

export default function HomePage() {
  return (
    <div data-testid="home-page">
      <Hero />
      <About />
      <Services />
      <ReviewsPreview />
      <Contact />
    </div>
  );
}
